// extracted by css-extract-rspack-plugin
export default {"full":"kCKs9S","iconOnly":"Ad6F0V"};